import Cookies from 'js-cookie';

import forceLogoutHandler from './a.users.forceLogoutHandler';

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// ResendEmailVerificationCode
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestResendEmailVerificationCode = packet => {
  return {
    type: 'REQUEST_RESEND_EMAIL_VERIFICATION_CODE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveResendEmailVerificationCodeSuccess = data => ({
  type: 'RECEIVE_RESEND_EMAIL_VERIFICATION_CODE_SUCCESS',
  data
})

export const receiveResendEmailVerificationCodeFail = data => ({
  type: 'RECEIVE_RESEND_EMAIL_VERIFICATION_CODE_FAIL',
  data
})

export const tryToResendEmailVerificationCode = packet => (dispatch, getState) => {

  dispatch(requestResendEmailVerificationCode(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/users/resend-email-verification-code', {
      method: 'post',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveResendEmailVerificationCodeSuccess(json.data));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveResendEmailVerificationCodeFail({errors:e, lastSubmit: packet}));
    })
}
